import * as Immutable from "immutable"

import { AbstractOperationMessage } from "./abstractOperationMessage"

export class PriceOperationMessage extends AbstractOperationMessage {    
}